import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8 11.513 12.12 14l-1.093-4.687 3.64-3.153-4.794-.407L8 1.333l-1.873 4.42-4.794.407 3.64 3.153L3.88 14 8 11.513Z" />
  </Icon>
);

export default memo(StarredIcon);
